import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from '@compumark/order-management-client';

import { GoodsAndServicesDialogComponent } from './goods-and-services-dialog/goods-and-services-dialog.component';

@Component({
  selector: 'app-goods-and-services-renderer',
  templateUrl: './goods-and-services-renderer.component.html',
  styleUrls: ['./goods-and-services-renderer.component.scss'],
  standalone: false,
})
export class GoodsAndServicesRendererComponent
  implements ICellRendererAngularComp
{
  private dialog = inject(MatDialog);

  public goodsAndServices!: string;
  private order!: Order;

  refresh(): boolean {
    return false;
  }

  checkOverflow(element: any): boolean {
    return (
      element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth
    );
  }

  agInit(params: ICellRendererParams): void {
    this.goodsAndServices = params.value;
    this.order = params.data;
  }

  openGoodsAndServicesDialog(): void {
    this.dialog.open(GoodsAndServicesDialogComponent, {
      data: {
        trademarkName: this.order.trademarkName,
        goodsAndServices: this.goodsAndServices,
      },
      width: '25vw',
      height: '100%',
      position: { right: '0' },
    });
  }
}
